<template lang="pug">
  .item
    BaseCheckbox(v-model="checked" label="" @change="change(false)" :disabled="!changeable" small crossing white)
    .number(v-if="number") {{ number }}
    template(v-if="editable")
      input.label(v-if="editing" type="text" :value="labelRaw" @input="onInput" ref="field" @keydown.enter="change(true)" @blur="change(false)")
      .label(v-else :class="{ crossed: checked }" v-linkify v-html="label" @click="$emit('edit')")
      Icon(name="copy" pointer @click.native="$emit('copy')" colored style="color: #788CA1").delete-item
      Icon(name="trash" pointer @click.native="$emit('delete')").delete-item
    template(v-else)
      .label(:class="{ crossed: checked }" v-linkify v-html="label")
</template>

<script>
import linkify from 'vue-linkify';
import htmlspecialchars from '@/utils/htmlspecialchars';

import BaseCheckbox from '@/components/BaseCheckbox.vue';

export default {
  name: 'CheckListItem',
  components: { BaseCheckbox },
  directives: { linkify },
  props: {
    editable: Boolean,
    changeable: Boolean,
    editing: Boolean,
    value: Object,
  },
  data() {
    return {
      label: '',
      number: '',
      checked: false,
      enterPressed: false,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        const { number, checked, label } = val;
        this.number = number;
        this.checked = checked;
        this.label = label;
      },
    },
    editing: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$nextTick(() => { this.$refs.field.focus(); });
        }
      },
    },
  },
  computed: {
    labelRaw() { return htmlspecialchars.decode(this.label); },
  },
  methods: {
    onInput(e) {
      this.label = htmlspecialchars.encode(e.target.value);
    },
    change(isEnterPress = false) {
      if (this.enterPressed) return;

      const item = {
        label: this.label,
        checked: this.checked,
        number: this.number,
      };

      if (isEnterPress) {
        this.$emit('enter', item);
        this.enterPressed = true;
      }

      this.$emit('change', item);
      this.$nextTick(() => { this.enterPressed = false; });
    },
  },
};
</script>

<style scoped lang="scss">

  .item {
    padding: 5px 0;
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .number {
    font-size: 12px;
    font-weight: 500;
    color: var(--color-accent) !important;
    width: 15px;
    flex-shrink: 0;
  }

  .label {
    box-sizing: border-box;
    min-height: 24px;
    padding: 5px 0;
    font-size: 12px;
    font-weight: 500;
    flex-grow: 1;
    outline: none;
    cursor: pointer;
    color: rgba(30, 49, 71, 1);

    &::v-deep {
      a {
        color: var(--color-accent) !important;
        word-break: break-all;
      }
    }

    &[contenteditable] {
      background: #fff;
    }

    &.crossed {
      text-decoration: underline;
      text-underline-offset: -0.35em;
      -webkit-text-decoration-skip-ink: none;
      text-decoration-skip-ink: none;
      text-decoration-thickness: 1px;
    }
  }

  .input {
    padding: 5px 0;
    font-size: 12px;
    font-weight: 500;
    flex-grow: 1;
  }

  .item:hover .delete-item {
    opacity: 1;
  }

  .delete-item {
    flex-shrink: 0;
    opacity: 0;
  }
</style>
